import React from 'react';
import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { Bookmark, BookmarkBorder } from '@mui/icons-material';
import { useBookmark } from '../hooks/useBookmark';

/**
 * 收藏按钮组件
 */
function BookmarkButton({ questionId, user, size = 'small', ...props }) {
  const { isBookmarked, toggling, toggleBookmark } = useBookmark(questionId, user);

  if (!user) {
    return null;
  }

  return (
    <Tooltip title={isBookmarked ? '取消收藏' : '收藏'}>
      <span>
        <IconButton
          size={size}
          onClick={toggleBookmark}
          disabled={toggling}
          {...props}
          sx={{
            color: isBookmarked ? 'primary.main' : 'text.secondary',
            '&:hover': {
              bgcolor: 'action.hover',
              color: 'primary.main'
            },
            ...props.sx
          }}
        >
          {toggling ? (
            <CircularProgress size={20} />
          ) : isBookmarked ? (
            <Bookmark />
          ) : (
            <BookmarkBorder />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
}

export default BookmarkButton;

